<template>
  <div class="sectionOuterBox bgForestGreen cWhite">
    <div class="sectionInnerBox text-left py-12">
      <v-container class="container">
        <v-row>
          <v-col md="6" sm="12">
            <div class="sectionListHeader md">{{ $t('teachers.sharePlans.title') }}</div>
            <div class="sectionImage2 hidden-md hidden-lg hidden-xlg my-10">
              <img class="boxShadow borderRadius8" src="https://cdn.planbook.com/images/teacherViews.png"
                :alt="$t('teachers.sharePlans.imageAlt')">
            </div>
            <div>
              <ul class="sectionList md pl-0 my-4">
                <li><i class="fal fa-arrow-circle-right" aria-hidden="true"></i><span>{{ $t('teachers.sharePlans.features.daily') }}</span></li>
                <li><i class="fal fa-arrow-circle-right" aria-hidden="true"></i><span>{{ $t('teachers.sharePlans.features.control') }}</span></li>
                <li><i class="fal fa-arrow-circle-right" aria-hidden="true"></i><span>{{ $t('teachers.sharePlans.features.ready') }}</span></li>
                <li><i class="fal fa-arrow-circle-right" aria-hidden="true"></i><span>{{ $t('teachers.sharePlans.features.substitute') }}</span></li>
                <li><i class="fal fa-arrow-circle-right" aria-hidden="true"></i><span>{{ $t('teachers.sharePlans.features.custom') }}</span></li>
              </ul>
            </div>
          </v-col>
          <v-col md="6" sm="12" class="hidden-xs hidden-sm hidden-xxs">
            <div class="sectionImage2">
              <img class="boxShadow borderRadius8" src="https://cdn.planbook.com/images/teacherViews.png"
                :alt="$t('teachers.sharePlans.imageAlt')">
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class SharePlans extends Vue {
}
</script>

<style lang="scss" scoped></style>
